import { useMemo } from 'react'
import { Button } from '~/components/button'
import { useInputMultiSelectContext } from '../../input-multi-select'
import type {
  InputMultiSelectClearButtonProps,
  InputMultiSelectScopedProps,
} from '../../input-multi-select.types'
import {
  InputMultiSelectClearButtonContainerVariants,
  InputMultiSelectClearButtonVariants,
} from './index.styles'

export const InputMultiSelectClearButton = ({
  __scopeInputMultiSelect,
  ...props
}: InputMultiSelectScopedProps<InputMultiSelectClearButtonProps>) => {
  const { size, disabled, isActive, readonly } = useInputMultiSelectContext(
    'InputMultiSelectClearButton',
    __scopeInputMultiSelect
  )

  const buttonSize = useMemo(() => {
    switch (size) {
      case 'md':
        return 'md'
      default:
        return 'ml'
    }
  }, [size])

  return (
    <div
      className={InputMultiSelectClearButtonContainerVariants({
        size,
        disabled,
        isActive,
        readOnly: readonly,
      })}
      aria-disabled={disabled}
    >
      <Button.Root
        {...props}
        size={buttonSize}
        disabled={disabled}
        variant="neutral-tertiary"
        className={InputMultiSelectClearButtonVariants({ size: buttonSize })}
      >
        <Button.Icon symbol="rdicon-dismiss-circle-outline" />
      </Button.Root>
    </div>
  )
}
